import {
  useEffect,
  useState
} from 'react';

import {
  AdvanceProvider
} from 'journeys';

import {
  CacheKeys
} from '../../../../constants';

export const useVoucherHistory = (loadContent) => {

  const [ voucherHistory, setVoucherHistory ] = useState({
    isLoading: true,
    isError: false,
    content: null
  });

  const getContent = async () => {

    const rewardHistoryResponse = await AdvanceProvider.getCachedItem(
      CacheKeys.VoucherAdvanceRewardHistory,
      null,
      AdvanceProvider.getRewardHistory
    );

    if (!rewardHistoryResponse?.ok || !rewardHistoryResponse?.result) {

      setVoucherHistory(prevState => ({
        ...prevState,
        isLoading: false,
        isError: true
      }));

      return;
    }

    setVoucherHistory(prevState => ({
      ...prevState,
      isLoading: false,
      isError: false,
      content: rewardHistoryResponse.result
    }));
  };

  useEffect(() => {

    if (!loadContent) {
      return;
    }

    getContent();

  }, [ loadContent ]);

  return voucherHistory;
};